<template>
  <div class="clubOptions">
    <div class="clubOptions__item">
        <ClubOptionIcon icon="1"></ClubOptionIcon>
        <div class="clubOptions__text">
          Обучение специалистов — создаём среду, в которой новички получают поддержку, а опытные профессионалы делятся экспертизой.
        </div>
    </div>

    <div class="clubOptions__item clubOptions__itemGreen">
      <ClubOptionIcon icon="2"></ClubOptionIcon>
      <div class="clubOptions__text">
        Душевная тусовка «для своих» — атмосфера клуба далека от сухих конференций. Здесь можно расслабиться, пошутить и быть собой.
      </div>

    </div>
    <div class="clubOptions__item">
      <ClubOptionIcon icon="3"></ClubOptionIcon>
      <div class="clubOptions__text">
        Просвещение и развитие — мы помогаем людям разбираться в вопросах кибербезопасности, учим работать с информацией и находить правду среди шума.
      </div>

    </div>
    <div class="clubOptions__item">
      <ClubOptionIcon icon="4"></ClubOptionIcon>
      <div class="clubOptions__text">
        Пространство общения — место, где можно свободно обмениваться опытом, идеями и находить единомышленников.
      </div>
    </div>


  </div>
</template>

<script>
import ClubOptionIcon from "@/components/ClubView/ClubOptionIcon.vue";

export default {
  name: "ClubOptions",
  components: {ClubOptionIcon}
}
</script>


<style scoped lang="scss">
.clubOptions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 0;

  &__item {
    flex: 1 1 220px;
    text-align: left;
    min-height: 200px;
    border-radius: 20px;
    padding: 14px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: var(--cd-card-bg);
    font-size: 16px;
    font-weight: 400;
    font-family: var(--cd-default-font);

    @include respond-to('sm') { flex: 1 1 calc(50% - 6px); }
    @include respond-to('xs') { flex: 1 1 100%; }
  }

  &__itemGreen {
    background: transparent;
    color: var(--cd-green);
    text-transform: uppercase;
  }
}
</style>

